import { ref } from 'vue';

export function useLoadingState() {
    const isLoading = ref(false);
    const errorMessage = ref('');
    const validationMessage = ref('');

    function setLoading(value) {
        isLoading.value = value;
    }

    function setError(message) {
        errorMessage.value = message;
    }

    function clearMessages() {
        errorMessage.value = '';
        validationMessage.value = '';
    }

    return { isLoading, errorMessage, validationMessage, setLoading, setError, clearMessages };
}
